<template>
    <v-app>
        <v-card
            width="500"
            outlined
            class="mx-auto my-auto"
            :loading="btnLoading"
        >
            <v-container class="my-auto">
                <v-row>
                    <v-card-title>
                        <v-icon large left>mdi-sigma</v-icon>
                        <span class="title font-weight-light">{{
                            $t("security.resetPassword")
                        }}</span>
                    </v-card-title>
                </v-row>

                <v-row>
                    <v-col lg="12" md="12" xs="12" cols="12" class="pb-0">
                        <v-form ref="form" autocomplete="chrome-off">
                            <v-text-field
                                :label="$t('security.newPassword')"
                                name="new password"
                                solo
                                flat
                                prepend-inner-icon="mdi-lock"
                                :rules="newPasswordRules"
                                type="password"
                                v-model="newPassword"
                                required
                                outlined
                                dense
                            />
                            <v-text-field
                                single-line
                                :label="$t('security.confirmPassword')"
                                name="repeat password"
                                solo
                                flat
                                prepend-inner-icon="mdi-lock"
                                :rules="repeatRules"
                                type="password"
                                v-model="repeatPassword"
                                required
                                outlined
                                dense
                            />
                        </v-form>
                    </v-col>
                </v-row>

                <v-row justify="center" class="pt-0 mt-0">
                    <v-col lg="12" md="12" xs="12" cols="12" align="center">
                        <v-btn
                            block
                            color="info"
                            :loading="btnLoading"
                            @click="handleReset"
                            :disabled="!valid"
                        >
                            {{ $t("common.form.submit") }}
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row>
                    <v-card-text class="mb-5 pb-0">
                        <p
                            class="text-center font-weight grey--text overline mb-0"
                        >
                            <a @click="redirectSignin">{{
                                $t("security.backToSignin")
                            }}</a>
                        </p>
                    </v-card-text>
                </v-row>
            </v-container>
        </v-card>
    </v-app>
</template>
<script>
import { resetPassword } from "@services/account/password";
import { snackbar } from "@components/mixins/snackbar";
import axios from "axios";

export default {
    name: "ResetPassword",
    mixins: [snackbar],
    props: {},
    watch: {
        newPassword() {
            if (this.$refs.form?.validate()) {
                this.valid = true;
            } else {
                this.valid = false;
            }
        },
        repeatPassword() {
            if (this.$refs.form?.validate()) {
                this.valid = true;
            } else {
                this.valid = false;
            }
        },
    },
    data() {
        return {
            token: null,
            valid: false,
            newPassword: "",
            repeatPassword: "",
            btnLoading: false,
            requestStatus: false,
            newPasswordRules: [
                (v) => !!v || this.$t("validation.passwordRequired"),
                (v) => v.length >= 8 || this.$t("validation.passwordMin"),
            ],
            repeatRules: [
                (v) => !!v || this.$t("validation.passwordRequired"),
                (v) => v.length >= 8 || this.$t("validation.passwordMin"),
                (v) =>
                    v === this.newPassword ||
                    this.$t("validation.passwordsNotMatch"),
            ],
        };
    },
    beforeRouteEnter(to, _1, next) {
        const token = to.query?.token;
        if (!!token) {
            next((vm) => {
                vm.token = token;
            });
        } else {
            next((vm) => {
                vm.$router.push({ name: "Signin" });
            });
        }
    },
    methods: {
        async handleReset() {
            const params = {
                password: this.newPassword,
            };
            this.btnLoading = true;

            let APIURL =
                document.querySelector("body").getAttribute("apiurl") ||
                process.env.VUE_APP_ENDPOINT;
            APIURL = APIURL + "/api/v1/security/reset-password";

            try {
                const res = await axios.post(APIURL, params, {
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                });
                if (res.status == 200) {
                    this.snackBarSuccess(res.data.msg, 1000);
                    setTimeout(() => {
                        this.redirectSignin();
                    }, 1000);
                }
                this.btnLoading = false;
            } catch (e) {
                this.snackBarDanger(e.response?.data?.msg || "Error");
                this.btnLoading = false;
            }
        },
        redirectSignin() {
            this.$router.push({ name: "Signin" });
        },
    },
};
</script>
